"use client";

import { isAuthError } from "@neondatabase/auth/next";
import { authViewPaths } from "@neondatabase/auth-ui/server";
import posthog from "posthog-js";
import { toast } from "sonner";
import { authClient } from "./client";

const EMAIL_VERIFICATION_PATH = `/auth/${authViewPaths.EMAIL_VERIFICATION}`;

/**
 * Requests a verification OTP when `href` is the email-verification path with
 * an `email` query param. Any other href is a no-op. Deliberately not awaited so
 * redirect does not wait on sending the verification code.
 */
export function sendCodeToVerifyEmail(href: string): void {
  let url: URL;
  try {
    url = new URL(href, window.location.origin);
  } catch {
    return;
  }
  if (url.pathname !== EMAIL_VERIFICATION_PATH) return;

  const email = url.searchParams.get("email");
  if (!email) return;

  // Deliberately not awaited
  authClient.emailOtp
    .sendVerificationOtp({ email, type: "email-verification" })
    .catch((err: unknown) => {
      toast.error("Could not send the code. Please try again.");
      posthog.captureException(
        err instanceof Error ? err : new Error(String(err)),
        {
          event: "send_verification_otp_failed",
          ...(isAuthError(err) && { status: err.status, code: err.code }),
        },
      );
    });
}
